// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Links-DefaultLink-module--cls1--34Zm3","cls2":"Links-DefaultLink-module--cls2--2FKOO Links-DefaultLink-module--cls1--34Zm3"};